import { Component, AfterViewInit, OnDestroy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NavController, NavParams, App } from 'ionic-angular';
import { Customer } from '../../app/models/Customer';
import { PaytronBackendService } from '../../providers/paytron-backend/paytron-backend.service';
import { Utils } from '../../providers/paytron-backend/utils';
import { CurrentAccount } from '../../app/models/CurrentAccount';
import { HttpErrorResponse } from '@angular/common/http';
import { AccountHolder } from '../../app/models/AccountHolder';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { TableDirective } from '../../directives/table-directive';
import { NavControllerService } from '../../providers/nav-controller/navControllerService';
import { Card } from '../../app/models/Card';
import { SecurityDepositTotal } from '../../app/models/SecurityDepositTotal';
import { Observable } from 'rxjs';
import { PoS } from '../../app/models/PoS';
import { Storage } from '@ionic/storage';
import { CardTransaction } from '../../app/models/CardTransaction';
import { TransactionType } from '../../app/models/TransactionType';
import { BsDatepickerConfig } from 'ngx-bootstrap';
import { Config } from '../../providers/config';
import { ConfigService } from '../../providers/config/config.service';
import { TranslateService } from '@ngx-translate/core';
import { AlertsHolder } from '../../app/models/AlertsHolder';
import { CardStatus } from '../../app/models/CardStatus';
import { RegisterActivity } from '../../app/models/RegisterActivity';
import { User } from '../../app/models/User';
import { Coupon } from '../../app/models/Coupon';
import { CardBlockReason } from '../../app/models/CardBlockReason';
import { LookalikeCardCreation } from '../../app/models/LookalikeCardCreation';

@Component({
  selector: 'page-customer-details',
  templateUrl: 'customer-details.html',
})
export class CustomerDetailsPage implements AfterViewInit, OnDestroy, OnInit {
  @ViewChild(TableDirective)
  private table: TableDirective;

  @ViewChild('currentAccountModal')
  private currentAccountModal: ModalDirective;

  @ViewChild('checkOutModal')
  private checkOutModal: ModalDirective;

  @ViewChild('confirmGiveBackModal')
  private confirmGiveBackModal: ModalDirective;

  @ViewChild('confirmCheckOutModal')
  private confirmCheckOutModal: ModalDirective;

  @ViewChild('dischargeInput')
  dischargeInput: ElementRef;

  @ViewChild('dischargeModal')
  private dischargeModal: ModalDirective;

  @ViewChild('insertCardModal')
  private insertCardModal: ModalDirective;

  @ViewChild('deleteCustomerModal')
  private deleteCustomerModal: ModalDirective;

  @ViewChild('updateCardModal')
  private updateCardModal: ModalDirective;

  @ViewChild('insertCardToCheckModal')
  private insertCardToCheckModal: ModalDirective;

  @ViewChild('insertCardToCloneModal')
  private insertCardToCloneModal: ModalDirective;

  private pageName: string = 'page-customer-details';
  private currentAccount: CurrentAccount = new CurrentAccount();
  private currentCustomer: Customer;
  private customerUuid: string;
  private isCheckOutRequired: boolean;
  private cards: Card[];
  private currentCard = new Card();
  private currentTransaction = new CardTransaction();
  private totalDeposit = new SecurityDepositTotal();
  private navControllerService: NavControllerService;
  public bsConfig: Partial<BsDatepickerConfig> = new BsDatepickerConfig();
  private currentConfiguration: Config;
  private pos: PoS;
  private checkOutTotal = 0;
  private checkOutAfterDischargeTotal = 0;
  private creditCardsTotal = 0;
  private debitCardsTotal = 0;
  private giveBackTotal = 0;
  private checkinDate = new Date();
  private checkoutDate = new Date();
  private alertsHolder: AlertsHolder;
  private cardReaderWebSocket: WebSocket;
  private currentAccountCardsSyncMap: Map<string, boolean>;
  private activity = new RegisterActivity();
  private customers: Customer[];
  private activDate = new Date();
  private expirDate = new Date();
  private notes = CardBlockReason;
  private activeCardsList: Card[];
  private cardUpgradeableCheck: string;
  private cardOkToUpdate: boolean;
  private freezeButton: boolean;
  private writingOnCard = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private backendService: PaytronBackendService,
    public storage: Storage,
    private utils: Utils,
    private configService: ConfigService,
    private app: App,

    private translate: TranslateService
  ) {
    this.currentCustomer = new Customer();
    this.customerUuid = this.navParams.get('customerUuid');
    this.navControllerService = new NavControllerService(app, storage);
    this.currentConfiguration = this.configService.getConfiguration();
    this.alertsHolder = new AlertsHolder(translate);
    this.storage.get('PoS').then((pos: PoS) => {
      this.pos = pos;
    });
    this.storage.get('registerActivity').then((activity: RegisterActivity) => {
      this.activity = activity;
    });
  }

  private loadCurrentCustomer() {
    this.backendService.getCustomer(this.customerUuid).subscribe(
      (data: Customer) => {
        this.utils.reformatAllAccountsOwnerInputDateStrings(data);
        this.currentCustomer = data;
        this.table.refreshTable();
      },
      (err: HttpErrorResponse) => {}
    );
  }

  ngOnInit(): void {
    this.bsConfig = this.currentConfiguration.datepickerConfig;
    this.table.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      order: [
        [3, 'asc'],
        [2, 'asc'],
      ],
    };
    this.checkOutModal.config = {
      ignoreBackdropClick: true,
      keyboard: false,
    };
    this.loadCurrentCustomer();
    this.dischargeModal.onShown.subscribe(() => this.utils.focus(this.dischargeInput));
  }

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {
    if (this.cardReaderWebSocket) {
      this.cardReaderWebSocket.close();
    }
  }

  setDates() {
    this.currentAccount.checkIn = this.checkinDate.toISOString();
    this.currentAccount.checkOut = this.checkoutDate ? this.checkoutDate.toISOString() : null;
  }

  addCurrentAccount(btnEvent: HTMLButtonElement) {
    btnEvent.disabled = true;
    this.currentAccount = new CurrentAccount();
    this.currentAccount.accountHolderType = AccountHolder.Customer;
    this.currentAccount.accountHolderUuid = this.currentCustomer.uuid;
    this.checkoutDate = null;
    this.submitCurrentAccount(btnEvent);
  }

  addCustomizedCurrentAccount() {
    this.currentAccount = new CurrentAccount();
    this.currentAccount.accountHolderType = AccountHolder.Customer;
    this.currentAccount.accountHolderUuid = this.currentCustomer.uuid;
    this.checkinDate = new Date();
    this.checkoutDate = null;
    this.isCheckOutRequired = false;
    this.currentAccountModal.show();
  }

  showCheckOut(currentAccount: CurrentAccount) {
    this.currentAccountCardsSyncMap = new Map<string, boolean>();
    this.resetShowCheckoutCardReaderWebSocket();
    this.checkOutTotal = 0;
    this.giveBackTotal = 0;
    this.currentAccount = currentAccount;
    this.showCheckOutModal(currentAccount);
    this.calculateTotal();
    this.checkDeposits();
  }

  private resetShowCheckoutCardReaderWebSocket(): void {
    this.resetCardReaderWebSocket(
      (webSocket: WebSocket) => {
        this.sendCardReaderHaltCommand(webSocket);
      },
      (webSocket: WebSocket, json: any) => {
        switch (json.messageType) {
          case 'event':
            switch (json.message.event) {
              case 'UNPROTECTED_CARD_DETECTED':
                this.sendCardReaderHaltCommand(webSocket);
                break;
              case 'CARD_DETECTED':
                this.sendCardReaderReadValuesCommand(webSocket, ['CARD_ID', 'CARD_ID_2', 'BALANCE']);
                break;
            }
            break;
          case 'command-response':
            switch (json.message.request.command) {
              case 'READ_VALUES':
                this.sendCardReaderHaltCommand(webSocket);
                this.currentAccount.cards.forEach((card: Card) => {
                  if (json.message.values.cardId == card.uuid) {
                    let balance: { amount: number; version: number } = json.message.values.balance;
                    let serverBalanceCents: number = this.utils.toCents(card.balance.valueOf());
                    let isSynchronized: boolean =
                      balance.amount == serverBalanceCents && balance.version == card.balanceVersion.valueOf();
                    this.currentAccountCardsSyncMap.set(card.uuid, isSynchronized);
                  } else if (json.message.values.cardId2 == card.uuid) {
                    this.currentAccountCardsSyncMap.set(card.uuid, true);
                  }
                });
                if (
                  !this.currentAccountCardsSyncMap.has(json.message.values.cardId) &&
                  !this.currentAccountCardsSyncMap.has(json.message.values.cardId2)
                ) {
                  this.alertsHolder.show('Wrong card.', 'danger');
                }
                break;
            }
            break;
          case 'command-error':
            switch (json.message.request.command) {
              case 'READ_VALUES':
                this.alertsHolder.show('Card read error.', 'danger');
                this.sendCardReaderHaltCommand(webSocket);
                break;
            }
            break;
        }
      },
      (webSocket: WebSocket) => {}
    );
  }

  checkDeposits() {
    this.currentAccount.cards.forEach((card) => {
      this.backendService.getSecurityDepositsByCard(card).subscribe((deposits: CardTransaction[]) => {
        card.securityDeposits = deposits;
      });
    });
  }

  calculateTotal() {
    this.checkOutTotal = 0;
    this.creditCardsTotal = 0;
    this.debitCardsTotal = 0;
    this.currentAccount.cards.forEach((card) => {
      if (card.balance <= 0) {
        this.creditCardsTotal += Math.abs(card.balance.valueOf());
      }
      if (card.balance > 0) {
        this.debitCardsTotal += card.balance.valueOf();
      }
    });
    this.checkOutTotal += this.creditCardsTotal;
    this.checkOutAfterDischargeTotal = this.checkOutTotal - this.debitCardsTotal;
  }

  discharge(card: Card) {
    this.currentCard = card;
    this.currentTransaction.movement = card.balance;
    this.showDischargeModal();
  }

  submitDischarge(dischargeBtn: HTMLButtonElement) {
    dischargeBtn.disabled = true;
    this.currentTransaction.type = TransactionType.Discharge;
    this.resetCardReaderWebSocket(
      (webSocket: WebSocket) => {
        this.sendCardReaderHaltCommand(webSocket);
        this.showInsertCardModal(dischargeBtn);
      },
      (webSocket: WebSocket, json: any) => {
        switch (json.messageType) {
          case 'event':
            switch (json.message.event) {
              case 'UNPROTECTED_CARD_DETECTED':
                this.sendCardReaderHaltCommand(webSocket);
                this.alertsHolder.show('Wrong card.', 'danger');
                dischargeBtn.disabled = false;
                webSocket.close();
                this.closeInsertCardModal();
                break;
              case 'CARD_DETECTED':
                this.sendCardReaderReadValuesCommand(webSocket, ['CARD_ID', 'BALANCE']);
                break;
            }
            break;
          case 'command-response':
            switch (json.message.request.command) {
              case 'READ_VALUES':
                if (json.message.values.cardId == this.currentCard.uuid) {
                  let balance: { amount: number; version: number } = json.message.values.balance;
                  let cardBalanceCentsBefore: number = this.utils.toCents(this.currentCard.balance.valueOf());
                  this.currentTransaction.pos = this.pos;
                  this.currentTransaction.type = TransactionType.Discharge;
                  this.currentTransaction.card = this.currentCard.uuid;
                  this.currentTransaction.balanceSnapshot = balance.amount;
                  this.currentTransaction.balanceVersion = balance.version + 1;
                  this.backendService.addDischargeTransaction(this.currentTransaction).subscribe(
                    (dischargeTx) => {
                      this.backendService.getCurrentAccount(this.currentAccount.uuid).subscribe(
                        (account) => {
                          for (let i: number = 0; i < this.currentCustomer.currentAccounts.length; i++) {
                            if (this.currentCustomer.currentAccounts[i].uuid == account.uuid) {
                              this.currentCustomer.currentAccounts[i] = account;
                            }
                          }
                          this.currentAccount = account;
                          let updatedCard: Card;
                          for (let i: number = 0; !updatedCard && i < account.cards.length; i++) {
                            if (account.cards[i].uuid == this.currentCard.uuid) {
                              updatedCard = account.cards[i];
                            }
                          }
                          if (updatedCard) {
                            let cardBalanceCentsAfter: number = this.utils.toCents(updatedCard.balance.valueOf());
                            let newBalance: number = cardBalanceCentsAfter - cardBalanceCentsBefore + balance.amount;
                            this.sendCardReaderWriteValuesCommand(webSocket, updatedCard, newBalance, dischargeTx);
                          } else {
                            this.alertsHolder.show(
                              'Failed to retreive updated data to align the card, which is now unusable.',
                              'danger'
                            );
                            this.blockCard(webSocket);
                            this.calculateTotal();
                            dischargeBtn.disabled = false;
                            this.closeInsertCardModal();
                            this.closeDischargeModal();
                          }
                        },
                        (err: HttpErrorResponse) => {
                          this.alertsHolder.show(
                            'Failed to retreive updated data to align the card, which is now unusable.',
                            'danger'
                          );
                          this.blockCard(webSocket);
                          dischargeBtn.disabled = false;
                          this.closeDischargeModal();
                          this.closeInsertCardModal();
                        }
                      );
                    },
                    (err: HttpErrorResponse) => {
                      let alertMessage: string = 'Transaction Rejected';
                      if (err.error.codeNumber === 'APP-025') {
                        this.currentCard.status = CardStatus.Blocked;
                        this.sendBlockedCardStatusCardReaderWriteValuesCommand(webSocket, this.currentCard);
                        this.currentCard.status = CardStatus[CardStatus.Blocked] as any;
                        alertMessage = 'The card was automatically blocked.';
                      }
                      this.alertsHolder.show(alertMessage, 'danger');
                      dischargeBtn.disabled = false;
                      this.sendCardReaderHaltCommand(webSocket);
                      this.closeDischargeModal();
                      this.closeInsertCardModal();
                      webSocket.close();
                    }
                  );
                } else {
                  this.sendCardReaderHaltCommand(webSocket);
                  this.alertsHolder.show('Wrong card.', 'danger');
                  dischargeBtn.disabled = false;
                  webSocket.close();
                  this.closeInsertCardModal();
                }
                break;
              case 'WRITE_VALUES':
                if (json.message.request.parameters.cardId == this.currentCard.uuid) {
                  if (json.message.request.parameters.cardStatus == 'Blocked') {
                    this.sendCardReaderHaltCommand(webSocket);
                    webSocket.close();
                  } else {
                    this.alertsHolder.show('Card write success.', 'success');
                    this.calculateTotal();
                    dischargeBtn.disabled = false;
                    this.sendCardReaderHaltCommand(webSocket);
                    this.closeDischargeModal();
                    this.closeInsertCardModal();
                    webSocket.close();
                  }
                }
                break;
            }
            break;
          case 'command-error':
            switch (json.message.request.command) {
              case 'READ_VALUES':
                if (json.message.request.parameters.cardId == this.currentCard.uuid) {
                  this.alertsHolder.show('Card read error.', 'danger');
                  this.closeInsertCardModal();
                  dischargeBtn.disabled = false;
                  this.sendCardReaderHaltCommand(webSocket);
                  webSocket.close();
                }
                break;
              case 'WRITE_VALUES':
                if (json.message.request.parameters.cardId == this.currentCard.uuid) {
                  if (json.message.request.parameters.cardStatus == 'Blocked') {
                    this.sendCardReaderHaltCommand(webSocket);
                    webSocket.close();
                  } else {
                    this.alertsHolder.show('Card write error.', 'danger');
                    this.blockCard(webSocket);
                    this.closeInsertCardModal();
                    dischargeBtn.disabled = false;
                    this.calculateTotal();
                  }
                }
                break;
            }
            break;
        }
      },
      (webSocket: WebSocket) => {
        dischargeBtn.disabled = false;
      }
    );
  }

  dischargeWithoutCard(dischargeBtn: HTMLButtonElement) {
    this.closeInsertCardModal();
    dischargeBtn.disabled = true;
    this.currentTransaction.pos = this.pos;
    this.currentTransaction.type = TransactionType.Discharge;
    this.currentTransaction.card = this.currentCard.uuid;
    this.currentTransaction.balanceSnapshot = this.utils.toCents(new Number(this.currentCard.balance).valueOf());
    this.currentTransaction.balanceVersion = 2147483647;
    this.currentTransaction.force = true;
    this.backendService.addDischargeTransaction(this.currentTransaction).subscribe(
      (card) => {
        this.loadCurrentCustomer();
        this.closeDischargeModal();
        this.closeInsertCardModal();
        this.closeCheckOutModal();
        this.calculateTotal();
        dischargeBtn.disabled = false;
        this.alertsHolder.show('The card was discharged and automatically blocked.', 'danger');
      },
      (err: HttpErrorResponse) => {}
    );
  }

  getSecurityDepositsByCurrentAccount(currentAccount) {
    this.backendService.getSecurityDepositsByCurrentAccount(currentAccount).subscribe(
      (deposits) => {
        this.totalDeposit = new SecurityDepositTotal();
        deposits.forEach((transaction) => {
          this.totalDeposit.notes += ' ' + transaction.notes;
          this.totalDeposit.quantity++;
          this.totalDeposit.total += transaction.movement.valueOf();
        });
      },
      (err: HttpErrorResponse) => {}
    );
  }

  editCurrentAccount(currentAccount: CurrentAccount) {
    this.utils.reformatAllCurrentAccountInputDateStrings(currentAccount);
    this.currentAccount = currentAccount;
    this.checkinDate = new Date(this.currentAccount.checkIn);
    this.checkoutDate = this.currentAccount.checkOut ? new Date(this.currentAccount.checkOut) : null;
    this.isCheckOutRequired = currentAccount.checkOut ? true : false;
    this.currentAccountModal.show();
  }

  isModifyRoomEnabled(currentAccount: CurrentAccount): boolean {
    let isModifyRoomEnabled: boolean = false;
    if (currentAccount) {
      if (currentAccount.cards) {
        let isCardBlocked: boolean = true;
        for (var i = 0; isCardBlocked && i < currentAccount.cards.length; i++) {
          var card = currentAccount.cards[i];
          isCardBlocked = CardStatus[card.status] == CardStatus.Blocked.toString();
        }
        isModifyRoomEnabled = isCardBlocked;
      } else if (!currentAccount.uuid) {
        isModifyRoomEnabled = true;
      }
    }
    return isModifyRoomEnabled;
  }

  submitCurrentAccount(submitButton: HTMLButtonElement) {
    this.backendService
      .getCurrentAccount(this.currentAccount.uuid)
      .subscribe(
        (currentAccount) => {
          const roomNumberFromServer = currentAccount.room;
          if (roomNumberFromServer !== this.currentAccount.room) {
            this.updateCardModal.show();
          }
        },
        (err: HttpErrorResponse) => {}
      )
      .add(() => {
        submitButton.disabled = true;
        this.setDates();
        this.backendService
          .saveOrUpdateCurrentAccount(this.currentAccount)
          .subscribe(
            (data: CurrentAccount) => {
              this.loadCurrentCustomer();
              this.table.refreshTable();
            },
            (err: HttpErrorResponse) => {}
          )
          .add(() => {
            this.currentAccountModal.hide();
            submitButton.disabled = false;
          });
      });
  }

  writeRoomNumberOnCard(submitButton: HTMLButtonElement) {
    this.freezeButton = false;
    this.setDates();
    this.backendService.getCurrentAccount(this.currentAccount.uuid).subscribe((currentAccount: CurrentAccount) => {
      this.backendService
        .saveOrUpdateCurrentAccount(currentAccount)
        .subscribe(
          (data: CurrentAccount) => {
            this.loadCurrentCustomer();
            this.table.refreshTable();
            this.backendService.getOwnerByCurrentAccount(data).subscribe((owner: Customer) => {
              let webSocket: WebSocket = (this.cardReaderWebSocket = new WebSocket(
                this.configService.getCardReaderWebSocketUrl()
              ));
              webSocket.addEventListener('error', (ev: Event) => {
                if (webSocket.readyState == WebSocket.CLOSED) {
                  this.alertsHolder.show('Card reader not found. Set it up and retry.', 'danger');
                } else if (webSocket.readyState == WebSocket.CONNECTING) {
                  this.alertsHolder.show('Card reader still connecting. Please wait.', 'danger');
                } else {
                  this.alertsHolder.show('Error while reading the card.', 'danger');
                  console.error('Card reader error', ev);
                }
              });
              webSocket.addEventListener('message', (ev: MessageEvent) => {
                let evData: any = JSON.parse(ev.data);
                switch (evData.messageType) {
                  case 'event':
                    switch (evData.message.event) {
                      case 'UNPROTECTED_CARD_DETECTED':
                      case 'CARD_DETECTED':
                        this.freezeButton = true;
                        this.writingOnCard = true;
                        if (evData.message.values.cardId) {
                          for (let i: number = 0; i < data.cards.length; i++) {
                            if (evData.message.values.cardId == data.cards[i].uuid) {
                              this.backendService.getCard(data.cards[i].uuid).subscribe((card) => {
                                this.currentCard = card;
                                this.currentCard.status = CardStatus.Blocked;
                                this.currentCard.notes = CardBlockReason[CardBlockReason.BlockedCard];
                                this.currentCard.blacklisted = true;
                                this.currentCard.currentAccountUuid = this.currentAccount.uuid;
                                this.currentCard.posUuid = this.pos ? this.pos.uuid : null;
                                this.activDate = new Date(this.currentCard.activationDate);
                                this.expirDate = this.currentCard.expirationDate
                                  ? new Date(this.currentCard.expirationDate)
                                  : null;
                                this.currentCard.activationDate = this.activDate.toISOString();
                                this.currentCard.expirationDate = this.expirDate ? this.expirDate.toISOString() : null;
                                this.backendService.saveOrUpdateCard(this.currentCard).subscribe((card) => {
                                  this.currentCard = card;
                                  this.table.refreshTable();
                                  const lookalikeCard: { posUuid: string; activationDate: string } = {
                                    posUuid: this.pos && this.pos.uuid,
                                    activationDate: new Date().toISOString(),
                                  };
                                  this.backendService
                                    .createLookalikeCard(evData.message.values.cardId, lookalikeCard)
                                    .subscribe(
                                      (lookalikeCardCreation: LookalikeCardCreation) => {
                                        this.currentCard = lookalikeCardCreation.card;
                                        this.currentCard.roomNumber = this.currentAccount.room;
                                        this.table.refreshTable();
                                        this.sendCardReaderFormatCardCommand(
                                          webSocket,
                                          lookalikeCardCreation.card,
                                          this.currentAccount,
                                          owner,
                                          null,
                                          lookalikeCardCreation.coupons
                                        );
                                      },
                                      (err: HttpErrorResponse) => {
                                        if (err.error.codeNumber === 'APP-025') {
                                          this.currentCard.status = CardStatus.Blocked;
                                          this.sendBlockedCardStatusCardReaderWriteValuesCommand(
                                            webSocket,
                                            this.currentCard
                                          );
                                          this.alertsHolder.show('The card was automatically blocked.', 'danger');
                                        } else {
                                          this.alertsHolder.show('Server error.', 'danger');
                                          this.cleanUpAfterCardWrite(webSocket);
                                        }
                                      }
                                    );
                                });
                              });
                            }
                          }
                          break;
                        }
                    }
                    break;
                  case 'command-response':
                    switch (evData.message.request.command) {
                      case 'FORMAT_CARD':
                        this.writingOnCard = false;
                        this.cleanUpAfterCardWrite(webSocket);
                        this.alertsHolder.show('Card write success.', 'success');
                        this.insertCardToCloneModal.hide();
                        this.insertCardToCheckModal.hide();
                        break;
                      case 'WRITE_VALUES':
                        if (this.currentCard.status === CardStatus.Blocked) {
                          this.writingOnCard = false;
                          this.cleanUpAfterCardWrite(webSocket);
                        }
                        break;
                    }
                    break;
                  case 'command-error':
                    switch (evData.message.request.command) {
                      case 'FORMAT_CARD':
                        if (evData.message.request.parameters.cardStatus == 'Blocked') {
                          this.sendCardReaderHaltCommand(webSocket);
                          webSocket.close();
                        } else {
                          this.alertsHolder.show('Card write error.', 'danger');
                          this.currentCard.status = CardStatus.Blocked;
                          this.currentCard.currentAccountUuid = this.currentAccount.uuid;
                          this.backendService.saveOrUpdateCard(this.currentCard).subscribe(
                            (card: Card) => {
                              this.currentCard = card;
                              this.alertsHolder.show('The card was automatically blocked.', 'danger');
                            },
                            (error: any) => {
                              console.error(error);
                              this.alertsHolder.show('Do not use the card again. Block it manually.', 'danger');
                            }
                          );
                          this.sendBlockedCardStatusCardReaderWriteValuesCommand(webSocket, this.currentCard);
                        }
                        break;
                    }
                    break;
                }
              });
              this.cardReaderWebSocket.addEventListener('open', (ev: Event) => {
                this.sendCardReaderHaltCommand(webSocket);
                this.showInsertCardToCloneModal();
              });
            });
          },
          (err: HttpErrorResponse) => {}
        )
        .add(() => {
          this.currentAccountModal.hide();
        });
    });
  }

  checkCardOnCurrentAccount() {
    this.freezeButton = true;
    this.cardUpgradeableCheck = '';
    this.setDates();
    this.backendService.getCurrentAccount(this.currentAccount.uuid).subscribe((currentAccount: CurrentAccount) => {
      let webSocket: WebSocket = (this.cardReaderWebSocket = new WebSocket(
        this.configService.getCardReaderWebSocketUrl()
      ));
      webSocket.addEventListener('error', (ev: Event) => {
        if (webSocket.readyState == WebSocket.CLOSED) {
          this.alertsHolder.show('Card reader not found. Set it up and retry.', 'danger');
        } else if (webSocket.readyState == WebSocket.CONNECTING) {
          this.alertsHolder.show('Card reader still connecting. Please wait.', 'danger');
        } else {
          this.alertsHolder.show('Error while reading the card.', 'danger');
          console.error('Card reader error', ev);
        }
      });
      webSocket.addEventListener('message', (ev: MessageEvent) => {
        let evData: any = JSON.parse(ev.data);
        switch (evData.messageType) {
          case 'event':
            switch (evData.message.event) {
              case 'UNPROTECTED_CARD_DETECTED':
              case 'CARD_DETECTED':
                if (evData.message.values.cardId) {
                  for (let i: number = 0; i < currentAccount.cards.length; i++) {
                    if (evData.message.values.cardId == currentAccount.cards[i].uuid) {
                      this.backendService.getCard(currentAccount.cards[i].uuid).subscribe(
                        (card) => {
                          if (card.status.toString() == 'Active') {
                            this.cardOkToUpdate = true;
                            this.cardUpgradeableCheck =
                              'The card is correct, in order to proceed please remove the card from the reader.';
                            this.freezeButton = false;
                          } else {
                            this.cardOkToUpdate = false;
                            this.cardUpgradeableCheck = 'This card cannot be updated.';
                            this.freezeButton = true;
                          }
                          this.cleanUpAfterCardWrite(webSocket);
                        },
                        (err: HttpErrorResponse) => {
                          this.alertsHolder.show('Server error.', 'danger');
                          this.cleanUpAfterCardWrite(webSocket);
                        }
                      );
                    } else {
                      this.cardOkToUpdate = false;
                      this.cardUpgradeableCheck = 'This card is not owned in this current account.';
                      this.freezeButton = true;
                    }
                  }
                  break;
                }
            }
            break;
        }
      });
      this.cardReaderWebSocket.addEventListener('open', (ev: Event) => {
        this.sendCardReaderHaltCommand(webSocket);
        this.insertCardToCheckModal.show();
      });
    });
  }

  private cleanUpAfterCardWrite(cardReaderWebSocket: WebSocket, submitButton?: HTMLButtonElement) {
    this.closeInsertCardModal();
    submitButton && (submitButton.disabled = false);
    this.sendCardReaderHaltCommand(cardReaderWebSocket);
    cardReaderWebSocket.close();
  }

  submitGiveBack(giveBackBtn: HTMLButtonElement) {
    giveBackBtn.disabled = true;
    this.resetCardReaderWebSocket(
      (webSocket: WebSocket) => {
        this.sendCardReaderHaltCommand(webSocket);
        this.showInsertCardModal(giveBackBtn);
      },
      (webSocket: WebSocket, json: any) => {
        switch (json.messageType) {
          case 'event':
            switch (json.message.event) {
              case 'UNPROTECTED_CARD_DETECTED':
                this.sendCardReaderHaltCommand(webSocket);
                this.alertsHolder.show('Wrong card.', 'danger');
                giveBackBtn.disabled = false;
                webSocket.close();
                this.closeInsertCardModal();
                break;
              case 'CARD_DETECTED':
                this.sendCardReaderReadValuesCommand(webSocket, ['CARD_ID', 'CARD_ID_2', 'BALANCE']);
                break;
            }
            break;
          case 'command-response':
            switch (json.message.request.command) {
              case 'READ_VALUES':
                if (
                  json.message.values.cardId == this.currentCard.uuid ||
                  json.message.values.cardId2 == this.currentCard.uuid
                ) {
                  let balance: { amount: number; version: number };
                  let actualCardBalanceCentsBefore: number = this.utils.toCents(this.currentCard.balance.valueOf());
                  if (json.message.values.cardId == this.currentCard.uuid) {
                    balance = json.message.values.balance;
                  } else if (json.message.values.cardId2 == this.currentCard.uuid) {
                    balance = {
                      amount: actualCardBalanceCentsBefore,
                      version: this.currentCard.balanceVersion.valueOf(),
                    };
                  }
                  this.backendService
                    .giveBackAllDepositsByCard(this.currentCard, balance.amount, balance.version + 1, this.pos)
                    .subscribe(
                      (data: CardTransaction[]) => {
                        this.backendService.getCurrentAccount(this.currentAccount.uuid).subscribe(
                          (account) => {
                            for (let i: number = 0; i < this.currentCustomer.currentAccounts.length; i++) {
                              if (this.currentCustomer.currentAccounts[i].uuid == account.uuid) {
                                this.currentCustomer.currentAccounts[i] = account;
                              }
                            }
                            this.currentAccount = account;
                            if (json.message.values.cardId == this.currentCard.uuid) {
                              let lastTransaction: CardTransaction;
                              if (data && data.length > 0) {
                                lastTransaction = data[0];
                                for (let i: number = 1; i < data.length; i++) {
                                  if (data[i].balanceVersion > lastTransaction.balanceVersion) {
                                    lastTransaction = data[i];
                                  }
                                }
                              }
                              this.backendService.getCard(this.currentCard.uuid).subscribe(
                                (data) => {
                                  this.currentCard = data;
                                  let actualCardBalanceCentsAfter: number = this.utils.toCents(
                                    this.currentCard.balance.valueOf()
                                  );
                                  let newBalance: number =
                                    actualCardBalanceCentsAfter - actualCardBalanceCentsBefore + balance.amount;
                                  this.sendCardReaderWriteValuesCommand(
                                    webSocket,
                                    this.currentCard,
                                    newBalance,
                                    lastTransaction
                                  );
                                },
                                (err: HttpErrorResponse) => {
                                  this.alertsHolder.show(
                                    'Failed to retreive updated data to align the card, which is now unusable.',
                                    'danger'
                                  );
                                  this.blockCard(webSocket);
                                  giveBackBtn.disabled = false;
                                  this.closeInsertCardModal();
                                }
                              );
                            } else if (json.message.values.cardId2 == this.currentCard.uuid) {
                              this.showCheckOut(this.currentAccount);
                              this.getSecurityDepositsByCurrentAccount(this.currentAccount);
                              giveBackBtn.disabled = false;
                              this.sendCardReaderHaltCommand(webSocket);
                              this.closeConfirmGiveBackModal();
                              this.closeInsertCardModal();
                              webSocket.close();
                            }
                          },
                          (err: HttpErrorResponse) => {
                            this.alertsHolder.show(
                              'Failed to retreive updated data to align the card, which is now unusable.',
                              'danger'
                            );
                            this.blockCard(webSocket);
                            giveBackBtn.disabled = false;
                            this.closeInsertCardModal();
                          }
                        );
                      },
                      (err: HttpErrorResponse) => {
                        let alertMessage: string = 'Transaction Rejected';
                        if (err.error.codeNumber === 'APP-025') {
                          this.currentCard.status = CardStatus.Blocked;
                          this.sendBlockedCardStatusCardReaderWriteValuesCommand(webSocket, this.currentCard);
                          this.currentCard.status = CardStatus[CardStatus.Blocked] as any;
                          this.alertsHolder.show('The card was automatically blocked.', 'danger');
                        }
                        this.alertsHolder.show(alertMessage, 'danger');
                        giveBackBtn.disabled = false;
                        this.sendCardReaderHaltCommand(webSocket);
                        webSocket.close();
                        this.closeInsertCardModal();
                      }
                    );
                } else {
                  this.sendCardReaderHaltCommand(webSocket);
                  this.alertsHolder.show('Wrong card.', 'danger');
                  giveBackBtn.disabled = false;
                  webSocket.close();
                  this.closeInsertCardModal();
                }
                break;
              case 'WRITE_VALUES':
                if (json.message.request.parameters.cardId == this.currentCard.uuid) {
                  if (json.message.request.parameters.cardStatus == 'Blocked') {
                    this.sendCardReaderHaltCommand(webSocket);
                    webSocket.close();
                  } else {
                    this.alertsHolder.show('Card write success.', 'success');
                    this.showCheckOut(this.currentAccount);
                    this.getSecurityDepositsByCurrentAccount(this.currentAccount);
                    giveBackBtn.disabled = false;
                    this.sendCardReaderHaltCommand(webSocket);
                    this.closeConfirmGiveBackModal();
                    this.closeInsertCardModal();
                    webSocket.close();
                  }
                }
                break;
            }
            break;
          case 'command-error':
            switch (json.message.request.command) {
              case 'READ_VALUES':
                if (json.message.request.parameters.cardId == this.currentCard.uuid) {
                  this.alertsHolder.show('Card read error.', 'danger');
                  giveBackBtn.disabled = false;
                  this.sendCardReaderHaltCommand(webSocket);
                  webSocket.close();
                  this.closeInsertCardModal();
                }
                break;
              case 'WRITE_VALUES':
                if (json.message.request.parameters.cardId == this.currentCard.uuid) {
                  if (json.message.request.parameters.cardStatus == 'Blocked') {
                    this.sendCardReaderHaltCommand(webSocket);
                    webSocket.close();
                  } else {
                    this.alertsHolder.show('Card write error.', 'danger');
                    this.blockCard(webSocket);
                    giveBackBtn.disabled = false;
                    this.closeInsertCardModal();
                  }
                }
                break;
            }
            break;
        }
      },
      (webSocket: WebSocket) => {
        giveBackBtn.disabled = false;
      }
    );
  }

  private sendCardReaderHaltCommand(cardReaderWebSocket: WebSocket) {
    cardReaderWebSocket.send(
      JSON.stringify({
        messageType: 'command',
        message: {
          command: 'HALT',
        },
      })
    );
  }

  private sendCardReaderReadValuesCommand(cardReaderWebSocket: WebSocket, valuesToRead: string[]) {
    cardReaderWebSocket.send(
      JSON.stringify({
        messageType: 'command',
        message: {
          command: 'READ_VALUES',
          parameters: {
            valuesToRead: valuesToRead,
          },
        },
      })
    );
  }

  private sendCardReaderWriteValuesCommand(
    cardReaderWebSocket: WebSocket,
    card: Card,
    newBalance: number,
    lastTransaction: CardTransaction
  ) {
    let movementCents: number = this.utils.toCents(lastTransaction.movement.valueOf());
    cardReaderWebSocket.send(
      JSON.stringify({
        messageType: 'command',
        message: {
          command: 'WRITE_VALUES',
          parameters: {
            cardId: card.uuid,
            balance: {
              amount: newBalance,
              version: card.balanceVersion,
            },
            lastTransaction: {
              id: lastTransaction.uuid,
              posId: lastTransaction.pos.uuid,
              amount: movementCents,
              type: lastTransaction.type,
            },
          },
        },
      })
    );
  }

  private sendBlockedCardStatusCardReaderWriteValuesCommand(cardReaderWebSocket: WebSocket, card: Card) {
    cardReaderWebSocket.send(
      JSON.stringify({
        messageType: 'command',
        message: {
          command: 'WRITE_VALUES',
          parameters: {
            cardId: card.uuid,
            cardStatus: 'Blocked',
          },
        },
      })
    );
  }

  private blockCard(webSocket: WebSocket) {
    this.currentCard.status = CardStatus.Blocked;
    this.currentCard.currentAccountUuid = this.currentAccount.uuid;
    this.backendService.saveOrUpdateCard(this.currentCard).subscribe(
      (card: Card) => {
        this.currentCard = card;
        this.alertsHolder.show('The card was automatically blocked.', 'danger');
      },
      (error: any) => {
        console.error(error);
        this.alertsHolder.show('Do not use the card again. Block it manually.', 'danger');
      }
    );
    this.sendBlockedCardStatusCardReaderWriteValuesCommand(webSocket, this.currentCard);
  }

  doCheckOut(checkOutBtn: HTMLButtonElement) {
    checkOutBtn.disabled = true;
    let response = this.backendService.checkOut(this.currentAccount, this.pos.uuid);
    this.submitCheckOut(response, checkOutBtn);
  }

  doPartialCheckOut(checkOutBtn: HTMLButtonElement) {
    checkOutBtn.disabled = true;
    let response = this.backendService.partialCheckOut(this.currentAccount, this.pos.uuid);
    this.submitCheckOut(response, checkOutBtn);
  }

  submitCheckOut(response: Observable<CurrentAccount>, checkOutBtn: HTMLButtonElement) {
    response
      .subscribe(
        (data) => {
          this.currentAccount = data;
          this.loadCurrentCustomer();
          this.closeConfirmCheckOutModal();
          this.closeCheckOutModal();
        },
        (err: HttpErrorResponse) => {
          let errorMessage: string;
          if (err.error.codeNumber === 'APP-029') {
            errorMessage = 'Checkout forbidden due to not discharged blocked cards. Discharge the cards and retry.'
          } else {
            errorMessage = 'Server error.';
          }
          this.alertsHolder.show(errorMessage, 'danger');
        }
      )
      .add(() => {
        checkOutBtn.disabled = false;
      });
  }

  printStatement(currentAccount: CurrentAccount) {
    this.backendService.getCurrentAccountPdf(currentAccount.uuid).subscribe(
      (blob: Blob) => {
        const element = document.createElement('a');
        element.href = URL.createObjectURL(blob);
        element.download =
          this.currentCustomer.firstName +
          ' ' +
          this.currentCustomer.lastName +
          ' ' +
          new Date().toDateString() +
          '.pdf';
        document.body.appendChild(element);
        element.click();
      },
      (err: HttpErrorResponse) => {}
    );
  }

  showInsertCardToCloneModal() {
    this.insertCardToCloneModal.show();
  }

  showConfirmCheckOutModal() {
    this.confirmCheckOutModal.show();
  }

  closeConfirmCheckOutModal() {
    this.confirmCheckOutModal.hide();
  }

  showDischargeModal() {
    this.dischargeModal.show();
  }

  closeDischargeModal() {
    this.dischargeModal.hide();
    this.resetShowCheckoutCardReaderWebSocket();
  }

  showConfirmGiveBackAllModal(card) {
    this.currentCard = card;
    this.confirmGiveBackModal.show();
  }

  closeConfirmGiveBackModal() {
    this.confirmGiveBackModal.hide();
    this.resetShowCheckoutCardReaderWebSocket();
  }

  onSearchChange(searchString) {
    this.table.filterBySearchText(searchString);
  }

  closeCurrentAccountModal() {
    this.loadCurrentCustomer();
    this.currentAccountModal.hide();
  }

  showCheckOutModal(currentAccount) {
    this.checkOutModal.show();
    this.getSecurityDepositsByCurrentAccount(currentAccount);
  }

  closeCheckOutModal() {
    this.checkOutModal.hide();
  }

  showInsertCardModal(buttonToEnableOnCancel?: HTMLButtonElement) {
    this.insertCardModal['buttonToEnableOnClose'] = buttonToEnableOnCancel;
    this.insertCardModal.show();
  }

  showInsertCardToCheckModal() {
    this.insertCardToCheckModal.show();
  }

  closeInsertCardToCheckModal() {
    this.insertCardToCloneModal.hide();
    this.insertCardToCheckModal.hide();
    this.updateCardModal.show();
  }

  closeUpdateCardModal() {
    this.updateCardModal.hide();
  }

  closeInsertCardModal() {
    if (this.insertCardModal['buttonToEnableOnClose']) {
      (<HTMLButtonElement>this.insertCardModal['buttonToEnableOnClose']).disabled = false;
    }
    delete this.insertCardModal['buttonToEnableOnClose'];
    this.insertCardModal.hide();
  }

  showCustomersPage() {
    this.navControllerService.showCustomersPage();
  }

  showCurrentAccountDetails(currentAccount: CurrentAccount) {
    this.navControllerService.showCurrentAccountDetails(currentAccount.uuid);
  }

  isCheckInBeforeNow(currentAccount: CurrentAccount): boolean {
    return this.utils.isCheckInBeforeNow(currentAccount);
  }

  private resetCardReaderWebSocket(
    onOpen: (webSocket: WebSocket) => void,
    onMessage: (webSocket: WebSocket, json: any) => void,
    onError: (webSocket: WebSocket) => void
  ): void {
    if (this.cardReaderWebSocket) {
      this.cardReaderWebSocket.close();
    }
    let webSocket: WebSocket = (this.cardReaderWebSocket = new WebSocket(
      this.configService.getCardReaderWebSocketUrl()
    ));
    webSocket.addEventListener('error', (ev: Event) => {
      if (webSocket.readyState == WebSocket.CLOSED) {
        this.alertsHolder.show('Card reader not found. Set it up and retry.', 'danger');
      } else if (webSocket.readyState == WebSocket.CONNECTING) {
        this.alertsHolder.show('Card reader still connecting. Please wait.', 'danger');
      } else {
        this.alertsHolder.show('Error while reading the card.', 'danger');
        console.error('Card reader error', ev);
      }
      onError(webSocket);
    });
    webSocket.addEventListener('message', (ev: MessageEvent) => {
      let json: any = JSON.parse(ev.data);
      onMessage(webSocket, json);
    });
    webSocket.addEventListener('open', (ev: Event) => {
      onOpen(webSocket);
    });
  }

  cancelInsertCard() {
    this.cardReaderWebSocket.close();
    this.closeInsertCardModal();
  }

  getTitle(msg: string) {
    return this.translate.instant(msg);
  }

  deleteCustomer() {
    this.deleteCustomerModal.show();
  }

  closeDeleteCustomerModal() {
    this.deleteCustomerModal.hide();
  }

  submitDeleteCustomer() {
    let response = this.backendService.deleteCustomer(this.currentCustomer);
    response
      .subscribe(
        (data) => {
          this.alertsHolder.show('Customer successfully deleted', 'success');
          this.showCustomersPage();
        },
        (err: HttpErrorResponse) => {
          this.alertsHolder.show(err.status.toString() + ':' + err.error.message, 'danger');
        }
      )
      .add(() => {
        this.closeDeleteCustomerModal();
      });
  }

  hasTransactions(customer: Customer): boolean {
    let hasTransactions: boolean = false;
    for (let i: number = 0; !hasTransactions && i < this.currentCustomer.currentAccounts.length; i++) {
      for (let j: number = 0; !hasTransactions && j < this.currentCustomer.currentAccounts[i].cards.length; j++) {
        hasTransactions = this.currentCustomer.currentAccounts[i].cards[j].balanceVersion > 0;
        return hasTransactions;
      }
    }
  }

  private sendCardReaderFormatCardCommand(
    cardReaderWebSocket: WebSocket,
    card: Card,
    currentAccount: CurrentAccount,
    owner: Customer | User,
    pin: string,
    coupons: Coupon[]
  ) {
    let initialBalance: Number = card.initialAmount ? card.initialAmount : card.balance;
    let balanceCents: number = this.utils.toCents(initialBalance.valueOf());
    let activationDate: Date = new Date(card.activationDate);
    let activationTime: string = activationDate.toISOString();
    let expirationDate: Date = new Date(card.expirationDate);
    let expireTime: string = expirationDate.toISOString();
    let plafond = this.utils.toCents((card.secondCircuitPlafond || card.plafond).valueOf());
    let message: any = {
      messageType: 'command',
      message: {
        command: 'FORMAT_CARD',
        parameters: {
          cardId: card.uuid,
          activationTime: activationTime,
          expireTime: expireTime,
          cardType: card.type.name,
          pin: pin,
          userId: owner.uuid,
          cardId2: card.secondCircuitUuid,
          balance: {
            amount: balanceCents,
            version: card.balanceVersion,
          },
          cardStatus: card.status,
          cardName: card.name,
          plafond: plafond,
          ownerFirstName: owner.firstName,
          ownerLastName: owner.lastName,
        },
      },
    };
    if (currentAccount.room) {
      message.message.parameters.roomNumber = currentAccount.room;
    }
    if (card.initialRecharge) {
      let lastTransactionAmountCents = this.utils.toCents(card.initialRecharge.movement.valueOf());
      message.message.parameters.lastTransaction = {
        id: card.initialRecharge.uuid,
        posId: card.initialRecharge.pos.uuid,
        amount: lastTransactionAmountCents,
        type: card.initialRecharge.type,
      };
    }
    if (coupons && coupons.length > 0) {
      let plainCoupons: Coupon[] = [];
      let dailyCoupons: Coupon[] = [];
      coupons.forEach((value: Coupon) => {
        if (value.type.daily) {
          dailyCoupons.push(value);
        } else {
          plainCoupons.push(value);
        }
      });
      let couponsMessageValue: any[] = [];
      plainCoupons.forEach((coupon: Coupon) => {
        couponsMessageValue.push({
          code: coupon.type.code,
          amount: coupon.amount,
        });
      });
      message.message.parameters.coupons = couponsMessageValue;
      dailyCoupons.sort((a: Coupon, b: Coupon) => {
        let result = a.type.code - b.type.code;
        if (result == 0) {
          result = a.date - b.date;
        }
        return result;
      });
      let dailyCouponsMessageValue: any[] = [];
      let currentCode: number;
      let dailyAmounts: any[];
      dailyCoupons.forEach((dailyCoupon: Coupon) => {
        if (dailyCoupon.type.code != currentCode) {
          if (currentCode) {
            dailyCouponsMessageValue.push({
              code: currentCode,
              dailyAmounts: dailyAmounts,
            });
          }
          dailyAmounts = [];
          currentCode = dailyCoupon.type.code;
        }
        let dayOfStay: number = this.dailyCouponDateToDayOfStay(
          new Date(this.currentCard.activationDate),
          new Date(this.currentCard.expirationDate),
          new Date(dailyCoupon.date)
        );
        let dailyAmount: any = {
          dayOfStay: dayOfStay,
          amount: dailyCoupon.amount,
        };
        dailyAmounts.push(dailyAmount);
      });
      if (currentCode) {
        dailyCouponsMessageValue.push({
          code: currentCode,
          dailyAmounts: dailyAmounts,
        });
      }
      message.message.parameters.dailyCoupons = dailyCouponsMessageValue;
    }
    cardReaderWebSocket.send(JSON.stringify(message));
  }

  private dailyCouponDateToDayOfStay(
    cardActivationDate: Date,
    cardExpirationDate: Date,
    dailyCouponDate: Date
  ): number {
    let dayOfStay: number;
    let dummyDate: Date;
    for (let i: number = 0; !dayOfStay && (!dummyDate || cardExpirationDate >= dummyDate); i++) {
      dummyDate = new Date(cardActivationDate.getTime());
      dummyDate.setDate(dummyDate.getDate() + i);
      if (dummyDate.toDateString() == dailyCouponDate.toDateString()) {
        dayOfStay = i + 1;
      }
    }
    return dayOfStay;
  }
}



// WEBPACK FOOTER //
// ./src/pages/customer-details/customer-details.ts